<template>
  <v-row no-gutters>
    <CheckboxInput
      v-if="parameter.input_type === 'checkbox'"
      :show-buttons="props.showButtons"
      :parameter="props.parameter"
      :modbus-reload="props.modbusReload"
    />
    <SelectInput
      v-else-if="parameter.input_type === 'dropdown'"
      :show-buttons="props.showButtons"
      :parameter="props.parameter"
      :show-group="props.showGroup"
      :modbus-reload="props.modbusReload"
    />
    <SwitchInput
      v-else-if="parameter.input_type === 'switch'"
      :show-buttons="props.showButtons"
      :parameter="props.parameter"
      :show-group="props.showGroup"
      :modbus-reload="props.modbusReload"
    />
    <NumberInput
      v-else-if="parameter.input_type === 'fullnumber'"
      :show-buttons="props.showButtons"
      :parameter="props.parameter"
      :significance="props.significance"
      :show-group="props.showGroup"
      :modbus-reload="props.modbusReload"
      :full-number="true"
    />
    <NumberInput
      v-else-if="parameter.input_type === 'versionnumber'"
      :show-buttons="props.showButtons"
      :parameter="props.parameter"
      :significance="props.significance"
      :show-group="props.showGroup"
      :modbus-reload="props.modbusReload"
      :version-number="true"
    />
    <NumberInput
      v-else-if="
        parameter.type === 'float' ||
        parameter.type === 'int' ||
        parameter.type === 'uint16_t' ||
        parameter.type === 'uint32_t'
      "
      :show-buttons="props.showButtons"
      :parameter="props.parameter"
      :significance="props.significance"
      :show-group="props.showGroup"
      :modbus-reload="props.modbusReload"
    />
    <TextInput
      v-else-if="parameter.type === 'char2'"
      :show-buttons="props.showButtons"
      :parameter="props.parameter"
      :text-label="textInputLabel"
      :text-items="textItems"
      :modbus-reload="props.modbusReload"
    />
    <v-sheet v-else>
      name: {{ parameter.name }}, show-buttons:{{ showButtons }}, sign:
      {{ significance }}
    </v-sheet>
  </v-row>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useModbusStore } from "@/stores/useModbusStore";
import CheckboxInput from "@/components/configInput/CheckboxInput.vue";
import NumberInput from "@/components/configInput/NumberInput.vue";
import SelectInput from "@/components/configInput/SelectInput.vue";
import SwitchInput from "@/components/configInput/SwitchInput.vue";
import TextInput from "@/components/configInput/TextInput.vue";
import { ModbusParam } from "@/types/ModbusParam";

const modbusStore = useModbusStore();

const props = defineProps<{
  parameter: ModbusParam;
  showButtons?: boolean;
  showGroup?: boolean;
  significance: number;
  modbusReload: boolean;
}>();

const textInputLabel = computed(() => {
  const name = props.parameter.name.split("[")[0];
  const end = textItems.value.length * 2 - 1;
  return `${name}[0:${end}]`;
});

const textItems = computed<ModbusParam[]>(() => {
  if (props.parameter.type == "char2") {
    const paramName = props.parameter.name.split("[")[0];
    return modbusStore.params.filter(
      (param) => param.name?.indexOf(paramName) === 0,
    );
  } else {
    return [];
  }
});
</script>
